/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const SET_SETTINGS = 'uiActionTypes/SET_SETTINGS';
export const SET_SETTINGS_SUCCESS = 'uiActionTypes/SET_SETTINGS_SUCCESS';
export const SET_SETTINGS_FAILURE = 'uiActionTypes/SET_SETTINGS_FAILURE';
export const SAVE_SETTINGS = 'uiActionTypes/SAVE_SETTINGS';
export const SAVE_SETTINGS_SUCCESS = 'uiActionTypes/SAVE_SETTINGS_SUCCESS';
export const SAVE_SETTINGS_FAILURE = 'uiActionTypes/SAVE_SETTINGS_FAILURE';
export const CLEAR_SETTINGS = 'uiActionTypes/CLEAR_SETTINGS';
export const GET_SETTINGS = 'uiActionTypes/GET_SETTINGS';
export const GET_SETTINGS_SUCCESS = 'uiActionTypes/GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_FAILURE = 'uiActionTypes/GET_SETTINGS_FAILURE';

export interface SetSettings {
  type: typeof SET_SETTINGS;
  payload?:any,
}

export interface SetSettingsSuccess {
  type: typeof SET_SETTINGS_SUCCESS;
  payload?:any;
}

export interface SetSettingsFailure {
  type: typeof SET_SETTINGS_FAILURE;
  payload?:any;
}

export interface SaveSettings {
  type: typeof SAVE_SETTINGS;
  payload?:any,
}

export interface SaveSettingsSuccess {
  type: typeof SAVE_SETTINGS_SUCCESS;
  payload?:any;
}

export interface SaveSettingsFailure {
  type: typeof SAVE_SETTINGS_FAILURE;
  payload?:any;
}

export interface ClearSettings {
  type: typeof CLEAR_SETTINGS;
  payload?:any,
}

export interface GetSettings {
  type: typeof GET_SETTINGS;
  payload?:any,
}

export interface GetSettingsSuccess {
  type: typeof GET_SETTINGS_SUCCESS;
  payload?:any;
}

export interface GetSettingsFailure {
  type: typeof GET_SETTINGS_FAILURE;
  payload?:any;
}

